import gql from 'graphql-tag';

export const NAME = 'compositions_CaseDetailOverviewPanel_caseDelaysQuery';

export default gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      assetDowntimeMs
      caseDelays {
        id
        startTime
        endTime
        status
        reasonType
        customReason
        dealerResponse {
          dealer {
            ... on Dealer {
              id
              name
            }
            ... on CustomDealer {
              id
              name
            }
          }
        }
      }
      isDelayed
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/withCaseDelays/caseDelaysQuery.js